export default class TypeCollection extends Array {
    static create(classes) {
        const collection = Object.create(TypeCollection.prototype);
        if (typeof classes === 'undefined') {
            return collection;
        }
        if (Array.isArray(classes) === false) {
            classes = [classes];
        }
        collection.push(...classes);
        return collection;
    }
    constructor(classes) {
        super(...classes);
    }
    contains(clas) {
        return this.filter((value) => value === clas).length > 0;
    }
}
//# sourceMappingURL=TypeCollection.js.map